import React from "react";
import { Trash2, X } from "lucide-react";

export default function DeleteConfirmModal({ isOpen, onClose, onConfirm }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm p-5 space-y-4">
        <div className="flex items-center justify-between">
          <h3 className="text-base font-semibold text-bookish-purple">Delete Block</h3>
          <button type="button" onClick={onClose} className="p-1 hover:bg-bookish-purple/10 rounded-lg transition-colors">
            <X size={18} />
          </button>
        </div>

        <div className="flex flex-col items-center gap-3 py-2">
          <div className="w-12 h-12 rounded-full bg-red-50 flex items-center justify-center">
            <Trash2 size={24} className="text-red-500" />
          </div>
          <p className="text-sm text-bookish-purple/70 text-center">
            Delete this block? This action cannot be undone.
          </p>
        </div>

        <div className="flex gap-2 pt-2 border-t border-bookish-purple/8">
          <button
            onClick={onClose}
            className="flex-1 px-3 py-2 text-sm font-medium rounded-lg border border-bookish-purple/15 hover:bg-bookish-purple/5"
          >
            Cancel
          </button>
          <button
            onClick={() => { onConfirm(); onClose(); }}
            className="flex-1 px-3 py-2 text-sm font-medium rounded-lg bg-red-500 text-white hover:bg-red-600 transition-colors"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
}
